export default __webpack_public_path__ + "fonts/53036a05f6557c05e49104bf15e98934.woff2";